import * as cn from 'classnames'
import * as styles from 'styles/pages/Styleguide.css'
import Button from 'components/features/pfm/Button/Button'
import ExpandButton from 'components/atoms/buttons/ExpandButton'
import { Caption } from 'components/atoms/Text'
import { PostShareButton } from 'components/features/pfm/SegmentButton/PostShareButton'
import { PostLikeButton } from 'components/features/pfm/SegmentButton/PostLikeButton'
import { PostFollowButton } from 'components/features/pfm/SegmentButton/PostFollowButton'
import { CommentLikeButton } from 'components/features/pfm/SegmentButton/CommentLikeButton'

const Buttons = (
  <>
    <Button text='blue' theme='blue' />
    <Button text='outlined' style='outlined' />
    <Button text='hollow' style='hollow' />
    <Button text='gray' theme='gray' />
    <Button text='lightBlue' theme='lightBlue' />
    <Button text='midnight' theme='midnight' />
  </>
)

const SGButtons = () => (
  <>
    <section className={ cn(styles.sgSection, styles.fullWidth) }>
      <Caption text='Segmented Button' />
      <div className={ styles.buttonRow }>
        <PostShareButton title='Boom' content='Shaka-laka' url='https://statusmoney.com' onShare={ () => { /* do nothing */ } } />
        <PostLikeButton counter={ 5 } pressed={ false } />
        <PostLikeButton counter={ 46 } pressed />
        <PostFollowButton counter={ 15 } pressed={ false } />
        <PostFollowButton counter={ 150 } pressed />
        <CommentLikeButton counter={ 50 } pressed={ false } />
        <CommentLikeButton counter={ 50 } pressed />
      </div>
    </section>
    <section className={ cn(styles.sgSection, styles.fullWidth) }>
      <div className={ cn(styles.noon, styles.buttonRow) }>
        { Buttons }
        <Caption text='noon' />
      </div>
      <div className={ cn(styles.dawn, styles.buttonRow) }>
        { Buttons }
        <Caption text='dawn' />
      </div>
      <div className={ cn(styles.dusk, styles.buttonRow) }>
        { Buttons }
        <Caption text='dusk' />
      </div>
      <div className={ cn(styles.midnight, styles.buttonRow) }>
        { Buttons }
        <Caption text='midnight' />
      </div>
      <div className={ styles.buttonRow }>
        <ExpandButton isExpanded onClick={ () => null } />
        <ExpandButton isExpanded={ false } onClick={ () => null } />
        <Caption text='Expand Button' />
      </div>
    </section>
  </>
)

export default SGButtons
